module.exports = __webpack_public_path__ + "img/login-icon.d284db89.jpg";